import React, { FC } from "react";
import { useController, useFormContext } from "react-hook-form";

import Box from "@mui/material/Box";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormHelperText from "@mui/material/FormHelperText";

import { RadioButtonInputProps } from "./types";

const StyledFormRadioButton: FC<RadioButtonInputProps> = (props) => {
  const {
    name,
    title,
    rules,
    options,
    defaultValue = "",
    ...inputProps
  } = props;

  const formContext = useFormContext();
  const {
    control,
    formState: { errors: { [name]: { message = "" } = {} } = {} },
  } = formContext;

  const {
    field: { value = "", onChange },
  } = useController({
    name,
    control,
    rules,
    defaultValue,
  });

  return (
    <Box textAlign="left" sx={{ mb: 2, ...inputProps.sx }}>
      {title && (
        <Typography variant="subtitle2" color="grey800" mb={1}>
          {title}
        </Typography>
      )}
      <FormControl
        error={!!message}
        component="fieldset"
        variant="standard"
        {...inputProps}
      >
        <RadioGroup defaultValue={defaultValue} name={name}>
          {options.map((option, index) => (
            <FormControlLabel
              key={`radio-${name}-${index}`}
              value={option}
              control={
                <Radio
                  checked={value === option}
                  onChange={() => onChange(option)}
                />
              }
              label={option}
            />
          ))}
        </RadioGroup>
        <FormHelperText>
          {typeof message === "string" ? message : ""}
        </FormHelperText>
      </FormControl>
    </Box>
  );
};

export default StyledFormRadioButton;
